
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({})
export default class DeleteTagPopup extends Vue {
  close() {
    this.$emit('onClose');
  }

  deleteTag() {
    this.$emit('onDeleted');
    this.$emit('onClose');
  }
}
